import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OK_LABEL } from '@common/constants';
import { IAlertDialogData } from 'src/app/core/models/dialog.model';
import { CBXDialogData } from '../../services/dialog/dialog.service';
import { PreLoginService } from "src/app/pre-login/pre-login.service";

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent implements OnInit {

  buttonLabel:string = "";
  iscobStatus: boolean;
  constructor(
    private dialogRef: MatDialogRef<AlertDialogComponent>,
    private __preLoginService: PreLoginService,
    @Inject(MAT_DIALOG_DATA) protected data: CBXDialogData
  ) { }

  ngOnInit(): void {
    this.iscobStatus= this.__preLoginService.isCOB;
    // this.buttonLabel = this.data.buttonLabel ? this.data.buttonLabel : OK_LABEL;
  }

  close(){
    this.dialogRef.close(1);
  }

}
